<button mat-button color="primary" style="background-color: rgb(232 232 232);color: rgb(36,138,227);" (click)="onClick()">
    <span *ngIf="!isFileUploading && !isFileUploaded">{{'Upload a File*'}}</span>
    <span *ngIf="!isFileUploading && isFileUploaded">{{'Selected File*'}}</span>
    <span *ngIf="isFileUploading" >{{'Uploading...*'}}</span>
</button>
<span *ngIf="fileUploadError">Error uploading file</span>

<br />
<span *ngIf="fileHasScanError" style="color: red;" id="scanErrorMessage">{{scanErrorMessage}}</span>
<input [required]="required" type="file" id="fileUpload" name="fileUpload" 
   [accept]="allowedFileTypeExtensions" style="display:none;" multiple/>
   <div>
    <ul>
        <li *ngFor="let fileDetail of documentFileList">
            <span>{{fileDetail.Name}}</span>
        </li>
    </ul>
</div>